// Date / datetime formatting utilities.
// All dates display as dd.mm.yyyy; all datetimes as mm.dd.yy HH:MM IST.

const IST_OFFSET_MINUTES = 330; // UTC+5:30

function pad(n, w = 2) {
    return String(n).padStart(w, "0");
}

/** Format a date-only value (YYYY-MM-DD or ISO) as dd.mm.yyyy. */
export function formatDate(value) {
    if (!value) return "—";
    const s = String(value);
    // Pure date string: YYYY-MM-DD
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    // ISO datetime — render its calendar date in IST.
    const d = new Date(s);
    if (isNaN(d)) return s;
    const ist = new Date(d.getTime() + IST_OFFSET_MINUTES * 60_000);
    return `${pad(ist.getUTCDate())}.${pad(ist.getUTCMonth() + 1)}.${ist.getUTCFullYear()}`;
}

/** Format a datetime as mm.dd.yy HH:MM IST. */
export function formatDateTime(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d)) return String(value);
    const ist = new Date(d.getTime() + IST_OFFSET_MINUTES * 60_000);
    const yy = String(ist.getUTCFullYear()).slice(-2);
    return `${pad(ist.getUTCMonth() + 1)}.${pad(ist.getUTCDate())}.${yy} ${pad(ist.getUTCHours())}:${pad(ist.getUTCMinutes())} IST`;
}

/** Compute days difference between today (IST) and a date (YYYY-MM-DD or ISO). */
export function daysUntil(value) {
    if (!value) return null;
    const target = new Date(value);
    if (isNaN(target)) return null;
    const now = new Date();
    return Math.floor((target - now) / 86_400_000);
}
